import { Navigate } from 'react-router';
import { config } from '../../config/env';

const QueuesPage = () => {
  return <Navigate to={`${config.apiUrl}/queues`} />;
};

export default QueuesPage;
